import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { Button } from '@/components/shadcn/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { TooltipButton } from '@/components/ui/TooltipButton'
import clsx from 'clsx'
import { useState } from 'react'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { StatementEditorV2ContentDataType, StatementEditorV2SubmissionAction } from '../types'

export function SubmitAction({
  action,
  formData,
  tooltip,
}: {
  action: StatementEditorV2SubmissionAction
  formData?: StatementEditorV2ContentDataType | Record<string, unknown>
  tooltip?: string
}) {
  const [isOpen, setIsOpen] = useState(false)
  const { handlerId, id: actionId, confirmationMessage, label, icon, requireConfirmation } = action
  const actionTooltip = tooltip ?? label
  const { tileFilterSelections } = useTileFilters()
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(
    handlerId,
    [...tileFilterSelections, { actionId }],
    actionId,
    {
      onSuccess: () => setIsOpen(false),
    }
  )

  const onSubmit = () => {
    submitForm((formData ?? {}) as Record<string, unknown>)
  }

  const trigger = (
    <Button
      disabled={action.isDisabled}
      size="icon"
      variant="ghost"
      className={clsx('h-8 w-8', { 'rounded-full': icon })}
      onClick={requireConfirmation ? undefined : onSubmit}
    >
      {icon ? <DynamicIcon iconName={icon} /> : <span className="sr-only">{label}</span>}
    </Button>
  )

  if (requireConfirmation) {
    return (
      <ConfirmDialog
        trigger={trigger}
        triggerTooltip={actionTooltip}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        title={label}
        description={confirmationMessage}
        onConfirm={onSubmit}
        closeOnConfirm={false}
        isSubmitting={isSubmitting}
        confirmVariant="destructive"
      />
    )
  }

  return <TooltipButton tooltip={actionTooltip}>{trigger}</TooltipButton>
}
